/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import { handleBlobResponse } from '../../../../client/js/lib/download'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteLeaseFile (id: number) {
  return rest.delete(`/api/lease-files/${id}`)
}

export function downloadLeaseFileById (id: number) {
  return rest.get(`/api/lease-files/${id}/file`)
    .then(handleBlobResponse)
}

export function findManyLeaseFiles (params?: Record<string, any>): Promise<HalDocument<{
  files: LeaseFile[]
}>> {
  return rest.get(`/api/lease-files?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function uploadLeaseFile (file: File, tmpRef: string, leaseId?: number, documentType?: string) {
  const fd = new FormData()
  fd.append('documentType', documentType)
  fd.append('file', file)
  fd.append('leaseId', String(leaseId))
  fd.append('tmpRef', tmpRef)
  return rest.post('/api/lease-files', { body: fd })
    .then((resp) => resp.json())
}
